/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Assign_Driver_Search_PlaceholderInputs */

const vi_assign_driver_search_placeholder = /** @type {(inputs: Assign_Driver_Search_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tìm theo tên tài xế`)
};

/**

* @param {Assign_Driver_Search_PlaceholderInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const assign_driver_search_placeholder = /** @type {((inputs?: Assign_Driver_Search_PlaceholderInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Assign_Driver_Search_PlaceholderInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_assign_driver_search_placeholder(inputs)
});